import { containerWidth } from "./globalConfig";

export function getDjContainerWidth() {
	const bodyWidth = document.querySelector("body").offsetWidth;

	const entries = Object.entries(containerWidth).reverse();
	const found = entries.find((element) => Number(element[0]) < bodyWidth);

	return found[1] || 320;
}
